<style scoped>
.receipt-item {
  margin: .75rem 0;
  align-items: stretch;
}
.media {
  margin-right: 1rem;
}
.media figure.image {
  width: 4.5rem;
  height: 4.5rem;
}
.content {
  flex-grow: 1;
  display: flex;
  flex-wrap: wrap;
  align-content: space-between;
}
.content > div {
  width: 100%;
}
</style>

<template>
  <div class="receipt-item level is-mobile is-c-normal-text">
    <div class="media">
      <figure class="image">
        <cachalog-img :type="'background'" :caption="image.caption" :full-path="image.full_path"
          :source="image.source"></cachalog-img>
      </figure>
    </div>
    <div class="content is-cs-5">
      <div>
        <p class="has-text-weight-bold">{{ item.name }}</p>
      </div>
      <div class="level is-mobile is-cs-6">
        <span>数量 <em class="is-cs-4">{{ item.quantity || 0 }}</em></span>
        <span><em class="is-cs-4">{{ item.price.value.toLocaleString() }}</em> 円（{{ item.price.tax ? '税込' : '税抜' }}）</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['item'],
  computed: {
    image () {
      return this.item.images && this.item.images[0] ? this.item.images[0] : {}
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/receipt-item-list.vue